module.exports = __webpack_public_path__ + "img/thumbnail_ArcticWolf_j_normal.49f41736.png";